import {
  GET_STATUS_FAIL,
  GET_STATUS_LIST,
  GET_STATUS_SUCCESS,
} from "src/constants/types";

export const statusReducers = (state = {}, actions) => {
  switch (actions.type) {
    case GET_STATUS_LIST:
      return {
        ...state,
        loading: true,
        error: "",
      };

    case GET_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        status: actions.payload,
        error: "",
      };

    case GET_STATUS_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    default:
      return state;
  }
};
